module.exports = __webpack_public_path__ + "img/py.2d2b51ec.svg";